module.exports = __webpack_public_path__ + "img/faq.2552acb5.svg";